import { ColumnPreference } from '../type';

/**
 * Carry over, at their previous place, the saved preferences a new layout does not
 * mention: they belong to columns absent from the table right now (an inactive
 * form's questions, for one) and must still be there when those columns come back.
 */
export const keepUnlistedPreferences = (next: ColumnPreference[], previous: ColumnPreference[]): ColumnPreference[] => {
  const listed = new Set(next.map(preference => preference.columnId));
  const merged = [...next];

  previous.forEach((preference, index) => {
    if (listed.has(preference.columnId)) return;
    const anchor = previous
      .slice(0, index)
      .reverse()
      .find(candidate => merged.some(entry => entry.columnId === candidate.columnId));
    const position = anchor ? merged.findIndex(entry => entry.columnId === anchor.columnId) + 1 : 0;
    merged.splice(position, 0, preference);
  });

  return merged;
};
